import React from 'react';

import Link from '../editor/Link'

const EditorBridPrimaryEditor = props => {

    // render
    return (
        <div>
            {props.children}
            <div className="form-group">
                <label className="col-sm-3 control-label">Tutył</label>
                <div className="col-sm-9">
                    <input type="text" name="title" className="form-control" defaultValue={props.settings.title} placeholder="Tytuł" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Opis</label>
                <div className="col-sm-9">
                    <input type="text" name="description" className="form-control" defaultValue={props.settings.description} placeholder="Opis" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Czytaj więcej</label>
                <div className="col-sm-9">
                    <Link value={props.settings.link} />
                </div>
            </div>
            <hr />
        </div>
    );
}


export default EditorBridPrimaryEditor;